import React from 'react';
import styled, { css } from 'styled-components';
import CaptionComponent from './Caption.component';

interface CellProps extends React.AllHTMLAttributes<HTMLDivElement> {
  after?: React.ReactNode;
  preText?: string;
  preTextLayout?: 'vertical' | 'horizontal';
  before?: React.ReactNode;
  stretched?: boolean;
}

const StyledCellPreText = styled.div`
  color: ${({ theme }) => theme.colors.GRAY.G200};
  line-height: 24px;
`;
const horizontalLayoutChildren = css`
  flex-direction: row;
`;
const verticalLayoutChildren = css`
  flex-direction: column;
`;
const stretchedStyle = css`
  display: block;
  width: 100%;
  flex-grow: 1;
  flex-basis: 0;
`;
export const StyledCellChildren = styled.div<{
  layout: string;
  stretched?: boolean;
}>`
  color: inherit;
  display: inline-flex;
  align-items: start;

  ${props => props.layout === 'vertical' && verticalLayoutChildren};
  ${props => props.layout === 'horizontal' && horizontalLayoutChildren};
  ${props => props.stretched && stretchedStyle};
`;
export const StyledCell = styled.div<{
  stretched?: boolean;
}>`
  display: flex;
  align-items: center;
  min-height: 24px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.NEUTRAL.N800};
  position: relative;

  ${props => props.stretched && stretchedStyle};
`;

const CellComponent = ({
  preText = '',
  preTextLayout = 'horizontal',
  stretched = false,
  className,
  children,
}: CellProps) => {
  return (
    <StyledCell stretched={stretched} className={className}>
      <StyledCellChildren
        stretched={stretched}
        layout={preTextLayout}
      >
        {preText && (
          <StyledCellPreText>
            <CaptionComponent level="2" weight="medium">
              {preText}&nbsp;
            </CaptionComponent>
          </StyledCellPreText>
        )}
        {children}
      </StyledCellChildren>
    </StyledCell>
  );
};

export default CellComponent;
